/*
  Toast - A wrapper for Carbon's ToastNotification component

  Refer to: README.toast.md
*/
import React, { useState, useEffect } from "react";
import { ToastNotification } from "carbon-components-react";

const styles = require("./styles.module.scss");

interface Props {
  toast: string; // the toast message
  toastKind: string;
  setToast: Function;
  setToastKind: Function;
}

const Toast = ({ toast, toastKind, setToast, setToastKind }: Props) => {
  const toastTimeoutMS = 4000;

  // If we set a toast, auto-clear it after a few seconds
  useEffect(() => {
    if (toast === "") return;

    setTimeout(() => {
      setToast("");
      setToastKind("");
    }, toastTimeoutMS + 500);
  }, [toast]);

  return (
    <div>
      {toast !== "" && (
        <ToastNotification
          title={toast}
          subtitle=""
          kind={toastKind}
          timeout={toastTimeoutMS}
          className={styles.toast}
          iconDescription="close the notification"
          caption=""
          lowContrast
          style={{
            padding: "0.5rem",
          }}
        />
      )}
    </div>
  );
};

interface UseToastHooks {
  toastHooks: any;
  notifyFunctions: {
    notifySuccess: (msg: string) => void;
    notifyError: (msg: string) => void;
  };
}

export const useToast = (): UseToastHooks => {
  const [toast, setToast] = useState<string>("");
  const [toastKind, setToastKind] = useState<string>("info");

  const notifySuccess = (msg: string) => {
    setToastKind("success");
    setToast(msg);
  };

  const notifyError = (msg: string) => {
    setToastKind("error");
    setToast(msg);
  };

  const toastHooks = {
    toast,
    setToast,
    toastKind,
    setToastKind,
  };

  const notifyFunctions = { notifySuccess, notifyError };

  return { toastHooks, notifyFunctions };
};

export default Toast;
